<section>
  <rappider-button [text]="'Back'"
                   [size]="'extra-small'"
                   [icon]="{name: 'fa fa-arrow-left'}">
  </rappider-button>

    <rappider-button [text]="'Test'"
                     [size]="'extra-small'"
                     [icon]="{name: 'fa fa-plug'}">
    </rappider-button>
    <rappider-button [text]="'Comments'"
                     [size]="'extra-small'"
                     [icon]="{name: 'fa fa-comments'}">
    </rappider-button>

</section>
